import services from "../services";
import router from "./../router";

const strict = true;

const getDefaultState = () => {
  return {
    oldPassword: null,
    newPassword: null,
    confirmNewPassword: null
  };
};

const state = getDefaultState();

const getters = {
  oldPassword: state => state.oldPassword,
  newPassword: state => state.newPassword,
  confirmNewPassword: state => state.confirmNewPassword
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateOldPassword(state, oldPassword) {
    state.oldPassword = oldPassword;
  },
  updateNewPassword(state, newPassword) {
    state.newPassword = newPassword;
  },
  updateConfirmNewPassword(state, confirmNewPassword) {
    state.confirmNewPassword = confirmNewPassword;
  }
};

const actions = {
  changeUserPassword({ commit, state }) {
    let payload = {
      oldPassword: state.oldPassword,
      newPassword: state.newPassword,
      portal: "HF"
    };

    return services.profileService
      .changePassword(payload)
      .then(() => {
        let success = {
          title: "profile.successChangePassword.title",
          message: "profile.successChangePassword.msg",
          closeButtonLabel: "profile.successChangePassword.btnLabel",
          closeButtonClb: () => {
            router.push({
              name: "login"
            });
          }
        };
        commit("success/openSuccessDialog", success, {
          root: true
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
